import { Component, OnInit } from '@angular/core';
import { urlUpload } from 'src/app/config/config';
import { GenericService } from 'src/app/services/generic/generic.service';
import { Location } from '@angular/common';
import { DocumentosService } from 'src/app/services/documentos/documentos.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-anexo-proce-botones',
  templateUrl: './anexo-proce-botones.component.html',
  styleUrls: ['./anexo-proce-botones.component.css']
})
export class AnexoProceBotonesComponent implements OnInit {
  public url_doc_procedimiento: string = '';
  public url_doc_anexo: string = '' ;
  public categoria: string = '' ;
  public database = 'documentos';
  public anexo_folder = '/documentos/anexos';
  public procedimientos_folder = '/documentos/procedimientos';
  public url_documentos = urlUpload ;
  constructor(
    private genericService: GenericService,
    private location: Location,
    private documentosService: DocumentosService
  ) { 
    this.categoria = this.location.path().replace("/dashboard/", ""); 
  }

  ngOnInit() {
    if (environment.appName === 'campanaragricola') {
      return;
    }
    this.documentosService.actualizarProcAnex.subscribe( resp => {
     // console.log('resp', resp);
      this.listarDocumentos();
      
    },error => {
      console.log('error', error);
    });
    this.listarDocumentos();
  }
  listarDocumentos() {
    this.genericService.getNameField('categoria', this.categoria, this.database).toPromise()
    .then( (resp: any) => {
      // console.log('resp getDocumentos', resp);
      if( resp.etiqueta == null || resp.etiqueta.length <= 0) {

      }else {
       
        this.categoria = resp.etiqueta[0]['categoria'];
        this.url_doc_anexo = resp.etiqueta[0]['doc_anexo'];
        this.url_doc_procedimiento = resp.etiqueta[0]['doc_procedimiento'];
    
      }
    }).catch( error => {
      console.log('error', error);
      
    })
  }

  viewDocumentoAnexo() {
    window.open(this.url_documentos + this.anexo_folder +'/'+ this.url_doc_anexo,'_blank');
 }

 viewDocumentoProcedimiento() {
    window.open(this.url_documentos + this.procedimientos_folder +'/'+ this.url_doc_procedimiento,'_blank');
 }
}
